import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getAbout } from '../services/api';
import '../styles/About.css';

const About = () => {
  const { t } = useTranslation();
  const [aboutData, setAboutData] = useState({
    title: 'About Me',
    description: 'Passionate architect with a vision for sustainable and innovative design.',
    profile_image: null,
    years_experience: 5,
    projects_completed: 20
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAboutData();
  }, []);

  const fetchAboutData = async () => {
  try {
    const response = await getAbout();
    if (response && response.data) {
      setAboutData(response.data);
    }
  } catch (error) {
    console.error('Error fetching about data:', error);
  } finally {
    setLoading(false);
  }
};

  if (loading) {
    return (
      <section id="about" className="about">
        <div className="about-loading">{t('about.loading')}</div>
      </section>
    );
  }

  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="section-header">
          <h2 className="section-title" data-aos="fade-up">
            {aboutData.title}
          </h2>
          <div className="section-divider"></div>
        </div>

        <div className="about-content">
          <div className="about-image-wrapper" data-aos="fade-right">
            {aboutData.profile_image ? (
              <img
                src={`${process.env.REACT_APP_API_URL}${aboutData.profile_image}`}
                alt="Profile"
                className="about-image"
              />
            ) : (
              <div className="about-image-placeholder">
                <i className="placeholder-icon">👤</i>
              </div>
            )}
            <div className="about-image-decoration"></div>
          </div>

          <div className="about-text" data-aos="fade-left">
            <p className="about-description">
              {aboutData.description}
            </p>

            <div className="about-stats">
              <div className="stat-item">
                <div className="stat-number">{aboutData.years_experience}+</div>
                <div className="stat-label">{t('about.yearsExperience')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{aboutData.projects_completed}+</div>
                <div className="stat-label">{t('about.projectsCompleted')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">{t('about.clientSatisfaction')}</div>
              </div>
            </div>

            <div className="about-skills">
              <h3>{t('about.coreExpertise')}</h3>
              <div className="skills-grid">
                <div className="skill-item">
                  <span className="skill-icon">🏗️</span>
                  <span>{t('about.skills.architectural')}</span>
                </div>
                <div className="skill-item">
                  <span className="skill-icon">🌿</span>
                  <span>{t('about.skills.environmental')}</span>
                </div>
                <div className="skill-item">
                  <span className="skill-icon">🏡</span>
                  <span>{t('about.skills.interior')}</span>
                </div>
                <div className="skill-item">
                  <span className="skill-icon">📐</span>
                  <span>{t('about.skills.modeling')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;